import useSWR from 'swr';
import { api } from '@/services/api';
import { Category } from '@/types';

// Cache key'leri için constant
const SWR_KEYS = {
  CATEGORIES_ALL: '/categories',
  CATEGORIES_ROOTS: '/categories/roots',
  CATEGORIES_TREE: '/categories?tree=true',
};

export const useCategories = () => {
  // Tüm kategorileri çek (düz liste)
  const useAllCategories = () => {
    const { data, error, isLoading } = useSWR<Category[]>(
      SWR_KEYS.CATEGORIES_ALL,
      () => api.categories.getAll(),
      {
        revalidateOnFocus: false, // Kullanıcı odaklandığında tekrar çekme (kategoriler sık değişmez)
        dedupingInterval: 60000, // 1 dakika cache
      }
    );

    return {
      categories: data || [],
      isLoading,
      isError: error,
    };
  };

  // Kök kategorileri çek (Navigasyon için optimize edilmiş)
  const useRootCategories = () => {
    const { data, error, isLoading } = useSWR<Category[]>(
      SWR_KEYS.CATEGORIES_ROOTS,
      async () => {
        const categories = await api.categories.getVisible();
        // Filter to get only root categories (no parentId)
        return categories.filter(c => !c.parentId);
      },
      {
        revalidateOnFocus: false,
        dedupingInterval: 60000,
      }
    );

    return {
      rootCategories: data || [],
      isLoading,
      isError: error,
    };
  };

  // Slug ile tekil kategori çek
  const useCategory = (slug?: string) => {
    const { data, error, isLoading } = useSWR<Category>(
      slug ? `/categories/slug/${slug}` : null,
      () => api.categories.getBySlug(slug!),
      {
        revalidateIfStale: false,
      }
    );

    return {
      category: data,
      isLoading,
      isError: error,
    };
  };

  return {
    useAllCategories,
    useRootCategories,
    useCategory,
  };
};
